'use client'

import type { ReactNode } from 'react'

import { useOrderFlow } from '@/app/[locale]/order/_context/order-flow-context'

import { ORDER_FLOW_STEPS } from '../../../_constants/order-flow-steps.const'
import { AStepPatientInfo } from '../../steps/patient-info/a-step-patient-info'
import { AStepSelectAmbulance } from '../../steps/select-ambulance/a-step-select-ambulance'
import { AStepSelectProduct } from '../../steps/select-product/a-step-select-product'
import { useRedirectMissingAmbulanceOnProductStep } from '../_hooks/use-redirect-missing-ambulance-on-product-step'
import { useScrollToTopOnOrderStep } from '../_hooks/use-scroll-to-top-on-order-step'

import { OrderFlowShell } from './order-flow-layout'

/**
 * Default funnel: ambulance → product → patient details.
 */
export function StandardOrderFlow() {
	const {
		currentStep,
		selectedAmbulanceSlug,
		cartProducts,
		confirmAmbulanceSelection,
		goToStep
	} = useOrderFlow()

	useRedirectMissingAmbulanceOnProductStep(currentStep, selectedAmbulanceSlug, goToStep)
	useScrollToTopOnOrderStep(currentStep)

	const stepBody = ((): ReactNode => {
		switch (currentStep) {
			case ORDER_FLOW_STEPS.SELECT_AMBULANCE:
				return <AStepSelectAmbulance onAmbulanceSelect={confirmAmbulanceSelection} />
			case ORDER_FLOW_STEPS.SELECT_PRODUCT:
				if (!selectedAmbulanceSlug) return null
				return <AStepSelectProduct ambulanceSlug={selectedAmbulanceSlug} />
			case ORDER_FLOW_STEPS.PERSONAL_DETAILS:
				if (!cartProducts.length) return null
				return <AStepPatientInfo />
		}
	})()

	return <OrderFlowShell hasProducts={cartProducts.length > 0}>{stepBody}</OrderFlowShell>
}
